/* Lotus Wheel spend-comparison card — on scroll the bars grow in one-by-one
   and the dollar figures count up (keeping their $ prefix + thousands commas).
   Progressive enhancement (final values rendered without JS); skipped for
   reduced motion. */
class SpendReveal extends HTMLElement {
  connectedCallback() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    this.counters = Array.from(this.querySelectorAll('[data-countup]'));
    // Stash final text, blank the numbers to 0 until revealed.
    this.counters.forEach((el) => {
      el.dataset.countraw = el.textContent;
      const prefix = (el.textContent.match(/^[^\d]*/) || [''])[0];
      el.textContent = prefix + '0';
    });

    this.classList.add('is-armed');
    this.observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((e) => e.isIntersecting)) {
          this.classList.add('is-revealed');
          this.counters.forEach((el) => this.countUp(el));
          this.observer.disconnect();
        }
      },
      { threshold: 0.3 }
    );
    this.observer.observe(this);
  }

  countUp(el) {
    const raw = el.dataset.countraw || el.textContent;
    const target = parseInt(raw.replace(/[^\d]/g, ''), 10);
    if (Number.isNaN(target)) {
      el.textContent = raw;
      return;
    }
    const prefix = (raw.match(/^[^\d]*/) || [''])[0];
    const suffix = (raw.match(/[^\d]*$/) || [''])[0];
    const duration = 1200;
    const start = performance.now();
    const tick = (now) => {
      const p = Math.min((now - start) / duration, 1);
      const eased = 1 - Math.pow(1 - p, 3);
      el.textContent = prefix + Math.round(eased * target).toLocaleString() + suffix;
      if (p < 1) requestAnimationFrame(tick);
      else el.textContent = prefix + target.toLocaleString() + suffix;
    };
    requestAnimationFrame(tick);
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }
}

customElements.define('spend-reveal', SpendReveal);
